import { render, staticRenderFns } from "./bindNewAcctDc.vue?vue&type=template&id=7f35bff2"
import script from "./bindNewAcctDc.vue?vue&type=script&lang=js"
export * from "./bindNewAcctDc.vue?vue&type=script&lang=js"
import style0 from "./bindNewAcctDc.vue?vue&type=style&index=0&id=7f35bff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports